// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padTop{
  padding-top: 30px;
}

.colorItems {
  color: black;
}

.colorItems:hover{
  color: #f89624;
  text-decoration: none;
}

.cardBackground {
  background-color: #F7F8F9;
}

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

.card {
  height: 100%;
}

.homescreenButton {
  height: 150px;
}
`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".padTop{\n  padding-top: 30px;\n}\n\n.colorItems {\n  color: black;\n}\n\n.colorItems:hover{\n  color: #f89624;\n  text-decoration: none;\n}\n\n.cardBackground {\n  background-color: #F7F8F9;\n}\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n.card {\n  height: 100%;\n}\n\n.homescreenButton {\n  height: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
